import { createContext, useContext, type ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";

import { anonClient } from "../lib/api";
import type { StorefrontMetaResponse } from "../types/storefront-api";

interface TenantApi {
  meta: StorefrontMetaResponse | undefined;
  loading: boolean;
  error: unknown;
}

const TenantContext = createContext<TenantApi | null>(null);

export function TenantProvider({ children }: { children: ReactNode }) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["storefront", "meta"],
    queryFn: async () =>
      (await anonClient.get("/api/v1/storefront/meta")) as StorefrontMetaResponse,
    staleTime: 5 * 60 * 1000,
  });

  return (
    <TenantContext.Provider value={{ meta: data, loading: isLoading, error }}>
      {children}
    </TenantContext.Provider>
  );
}

export function useTenant(): TenantApi {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error("useTenant must be used within <TenantProvider>");
  return ctx;
}
